import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';

import { Control, ColorEnvironment, Font, Text, Flexbox } from './Styles';
import Image from './Image';
import Cost from './Cost';
import PrimaryButton from './PrimaryButton';

import Locale from './models/Locale';

const styles = StyleSheet.create({
  description: {
    marginTop: 30,
    marginBottom: 30
  }
});

class EventInfo extends Component {
  render() {
    let image = this.props.event.isWildcard? this.props.event.iconFilename : this.props.event.photoFilename;
    return(
      <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter)}>
        <Image extraStyles={[Control.heroImage, ColorEnvironment.inverse]} filename={image} />
        <div className={css(Font.hero, Text.heading)}>{this.props.event.hazard}</div>
        <div className={css(styles.description, Text.textBlock, Font.heading)}>{this.props.event.description}</div>
        <Cost cost={this.props.event.impact} />
        <div onClick={this.handleDone.bind(this)}>
          <PrimaryButton>{Locale.localized("Next")}</PrimaryButton>
        </div>
      </div>
    );
  }

  handleDone() {
    this.props.onComplete(this.props.event)
  }
}

export default EventInfo;



// WEBPACK FOOTER //
// ./src/EventInfo.js